import { render, staticRenderFns } from "./ReAnalysisSds.vue?vue&type=template&id=ffaabe0e"
import script from "./ReAnalysisSds.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReAnalysisSds.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports